/**
 * reCAPTCHA v3 utility for Samvedanam forms.
 *
 * Usage in any form handler:
 *   import { getCaptchaToken, verifyCaptcha } from '../utils/captcha';
 *
 *   const token = await getCaptchaToken('contact_form');
 *   const result = await verifyCaptcha(token, 'contact_form');
 *   if (!result.success) { toast.error('...'); return; }
 */

import api from './api';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LcdnzstAAAAAPo8nlQKKk18-Y_gs8jjiruzlZr3';

/**
 * Execute reCAPTCHA v3 and return a token for the given action.
 * @param {string} action — identifies which form triggered the check
 * @returns {Promise<string>} reCAPTCHA token
 */
export const getCaptchaToken = (action = 'submit') => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('reCAPTCHA not loaded'));
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action })
        .then(resolve)
        .catch(reject);
    });
  });
};

/**
 * Verify the reCAPTCHA token via the backend.
 * @param {string} token — token from getCaptchaToken()
 * @param {string} action — must match the action used in getCaptchaToken()
 * @returns {Promise<{success: boolean, score?: number}>}
 */
export const verifyCaptcha = async (token, action = 'submit') => {
  try {
    const response = await api.post('/captcha/verify', { token, action });
    return response.data;
  } catch (error) {
    console.error('CAPTCHA verification error:', error);
    return { success: false };
  }
};
